import styled from 'styled-components';
import { GlobalToken, Modal } from 'antd';

import { CustomThemeToken } from '@/theme';

export const CreateNewContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme: { token } }) => token.colorBgContainer};
  height: 100%;
  width: 100%;
  .anticon {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading1}px;
    &:hover {
      cursor: pointer;
    }
  }
  .create-label {
    color: ${({ theme: { token } }) => token.colorText};
    margin-left: ${({ theme: { token } }) => token.marginXS}px;
  }
`;

export const RequestTierP = styled.p<{ theme: { token: GlobalToken } }>`
  .text-wrapper {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
  }
`;
export const TooltipLabel = styled.div<{ theme: { token: GlobalToken } }>`
  .content-label {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
  }
  .click-here-label {
    text-decoration: underline;
    cursor: pointer;
    color: ${({ theme: { token } }) => token.colorText};
    margin-right: ${({ theme: { token } }) => token.marginXXS}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    &:hover {
      cursor: pointer;
    }
  }
  .icon {
    color: ${({ theme: { token } }) => token.colorText};
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
    margin-right: ${({ theme: { token } }) => token.marginXS}px;
    width: 55px;
    height: 25px;
  }

  .main-wrapper {
    display: flex;
    padding: ${({ theme: { token } }) => token.paddingXXS}px;
  }
  .text-wrapper {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    .title-label {
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }
  }
  .icon-tier {
    margin-right: ${({ theme: { token } }) => token.marginXS}px;
    margin-top: ${({ theme: { token } }) => token.marginXL}px;
    &:hover {
      cursor: pointer;
    }
  }
`;

export const ModalWrapperNewControllerTier = styled.div`
  opacity: 0.3;
  display: flex;
  flex-direction: column;
  max-width: 400px;

  .node-widget-container {
    margin: 0;
  }
`;

export const ContainerNewControllerTier = styled.div<{ theme: { token: CustomThemeToken } }>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme: { token } }) => token.colorBgContainer};
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;

  .horizontal-border {
    height: 1px;
    width: 100%;
    background-color: ${({ theme: { token } }) => token.colorBorderSecondary};
  }

  .toggle-status-box {
    min-width: 92px;
  }

  .bottom-padding {
    padding: 0 ${({ theme: { token } }) => token.margin}px;
  }

  .top-padding {
    padding: ${({ theme: { token } }) => token.marginXS}px ${({ theme: { token } }) => token.margin}px;
  }

  .top-row {
    position: relative;
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    align-self: stretch;
    border-radius: ${({ theme: { token } }) => token.borderRadius}px ${({ theme: { token } }) => token.borderRadius}px 0
      0;

    .compressor-type-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${({ theme: { token } }) => token.marginXXS}px;
      flex-shrink: 0;

      .compressor-type-label {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }

    .compressor-title {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      flex: 1 1 0%;
      min-width: 0;
      gap: ${({ theme: { token } }) => token.marginXXS}px;

      .name {
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        color: ${({ theme: { token } }) => token.colorText};
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      }

      .model {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }

    .connectivity-icon-wrapper {
      width: auto;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: ${({ theme: { token } }) => token.marginXS}px;

      .icons-row {
        display: flex;
        flex-direction: row;
        gap: ${({ theme: { token } }) => token.marginXS}px;
        align-items: center;
        justify-content: center;

        > svg {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }

        > span,
        > div {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;

          svg {
            width: 19px;
            height: 19px;
          }
        }
      }

      .status-name {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }
  }

  .middle-row-container {
    display: flex;
    flex-direction: column;
    min-height: ${({ theme: { token } }) => token.marginXXL * 4}px;
  }

  .bottom-row {
    display: flex;
    align-items: center;
    align-self: stretch;
    gap: ${({ theme: { token } }) => token.marginLG}px;

    border-radius: 0 0 ${({ theme: { token } }) => token.borderRadiusLG}px
      ${({ theme: { token } }) => token.borderRadiusLG}px;

    .bottom-left-container {
      display: flex;
      justify-content: flex-start;
      flex-grow: 1;
      margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
      margin-top: ${({ theme: { token } }) => token.marginXS}px;

      .flex-row-centered {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: ${({ theme: { token } }) => token.marginXXS}px;
      }

      .metric-container {
        padding-right: ${({ theme: { token } }) => token.paddingXXS}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};

        .rpm-text {
          font-size: ${({ theme: { token } }) => token.fontSize}px;
          color: ${({ theme: { token } }) => token.colorTextSecondary};
          font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
          line-height: ${({ theme: { token } }) => token.lineHeight}px;
          text-align: center;
        }

        .rpm-value-box {
          display: flex;
          align-items: baseline;

          .rpm-value {
            font-size: ${({ theme: { token } }) => token.fontSize}px;
            color: ${({ theme: { token } }) => token.colorText};
          }

          .rpm-unit {
            font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
            color: ${({ theme: { token } }) => token.colorTextSecondary};
          }
        }
      }

      .flex-column-centered {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;

export const PopconfirmTitleContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  .text {
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .reason-container {
    padding: 20px 0;
  }

  .bold-text {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .info-message {
    margin-left: ${({ theme: { token } }) => token.marginMD}px;
    list-style: initial;
  }

  .spinner {
    height: 70px;
  }

  .error {
    border-color: ${({ theme: { token } }) => token.colorError};
  }

  .ep-select {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    gap: 2rem;
    .ant-select {
      width: 80%;
    }
  }

  .error-message {
    color: ${({ theme: { token } }) => token.colorError};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
    display: flex;
  }
`;

export const ProactiveEngineActivationBoxContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  min-width: 200px;

  .tooltip-overlay {
    max-width: 400px;
    white-space: normal;
    word-wrap: break-word;
  }

  .proactive-engine-state-box {
    display: flex;
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
    padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.padding}px;

    .engine-state-info-group {
      display: flex;
      flex-direction: column;
      margin: ${({ theme: { token } }) => token.marginXXS}px;

      .engine-mode-title {
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        color: ${({ theme: { token } }) => token.colorTextTertiary};
      }

      .engine-state {
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        color: ${({ theme: { token } }) => token.colorText};
        margin-top: ${({ theme: { token } }) => token.marginXXS}px;
      }
    }

    .change-engine-state {
      display: flex;
      align-items: center;
      padding-left: ${({ theme: { token } }) => token.paddingMD}px;
      margin-left: ${({ theme: { token } }) => token.margin}px;
    }
  }

  .deactivated-reason-container {
    color: ${({ theme: { token } }) => token.colorPrimary};
    cursor: pointer;
  }

  .ant-switch {
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
    height: 10px;
    width: 20px;

    .ant-switch-handle::before {
      background-color: ${({ theme: { token } }) => token.colorBorder};
      top: -5px;
      left: -2px;
      height: 16px;
      width: 16px;
      border-radius: 50%;
    }

    .ant-switch-loading-icon {
      top: 16px;
      left: 18px;
    }
  }

  .ant-switch-checked {
    .ant-switch-handle::before {
      background-color: ${({ theme: { token } }) => token.colorPrimary};
    }

    .ant-switch-loading-icon {
      color: ${({ theme: { token } }) => token.colorText};
      top: 10px;
      left: 2px;
    }

    &:focus {
      box-shadow: unset;
    }
  }

  .ant-switch-inner {
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  }

  .ant-popover-message {
    padding: 0;
  }

  .ant-popover-message-title {
    padding-left: 0;
  }

  .ant-popover-buttons {
    margin-bottom: 0;
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
  }
`;

export const DeactivationReasonModalContainer = styled(Modal)<{ theme: { token: GlobalToken } }>`
  .deactivation-details {
    .detail-row {
      color: ${({ theme: { token } }) => token.colorTextSecondary};
    }
  }
`;
